import { render, staticRenderFns } from "./DeliveryRules.vue?vue&type=template&id=3b3f19ee&scoped=true"
import script from "./DeliveryRules.vue?vue&type=script&lang=js"
export * from "./DeliveryRules.vue?vue&type=script&lang=js"
import style0 from "./DeliveryRules.vue?vue&type=style&index=0&id=3b3f19ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3f19ee",
  null
  
)

export default component.exports